import React, {Component} from "react"
import {
    Container,
    Col,
    Row} from 'reactstrap'
    import {isMobile} from 'react-device-detect';


    class Topics extends Component {
        constructor(props) {
          super(props);
          this.state = {
              activeTab: '1',
              activeColor:false,
              mobile:isMobile
          }
          this.toggle = this.toggle.bind(this);
        }

        toggle(tab) {
            if (this.state.activeTab !== tab) {
              this.setState({
                activeTab: tab,
                activeColor:true
              });
            }
          }
          
        render() {
    return(
        <Container className="gray introduction" fluid>
            <Container>
            <Row>
            <Col lg="9" md="10" sm="10" xs="12" className="text-left">
  <p className="grayline">&nbsp;</p>
<h2 className="display-3 text-white">How has the language evolved?</h2>
<p className="text-white explaintext">To better understand how language has shaped the political discourse, we also read through seven of the most notable documents that have featured in the Israeli-Palestinian conflict.</p>
<p className="text-white explaintext">Within each document, we used text summarisation techniques to count the number of times key topics were mentioned and, perhaps more interestingly, - not mentioned.</p>
<p className="text-white explaintext">The result is a series of graphics that reveal how the use of key topics has changed over the past century.</p>
</Col>
</Row>

<Row className="boxcard">
<Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section>
  <img src='./jpg/chartimages/palestine.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Mohamad Torokman / Reuters]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 palestine">Palestine (as a state)</span>
 <p className="text-white explaintext">Prior to the creation of Israel in 1948, "Palestine" and the "Government of Palestine" were used several times to refer to the Palestinian state.</p>
 <p className="text-white explaintext">There is no mention of Palestine as a state in either UN resolution 242 (1967), Resolution 478 (1980), or the Oslo Accords (1993). In fact, it was only in 2002 - in the Arab peace initiative - that The Council of the League of Arab States called for the <span className="hipalestine">"establishment of a Sovereign Independent Palestinian State"</span>.</p>
 <p className="text-white explaintext">Trump's new plan says the "United States will support the establishment of a Palestinian State" but only under a long list of preconditions.</p>  
 <small className="text-white">The topic "Palestine" is only counted when referenced as a state - ie not "Palestinian" people.</small>
 </section>
 <section>
   <img src='./jpg/maps/palestine.png' className="fluid" alt=""/>

 </section>
 </Col>

 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section>   
   <img src='./jpg/chartimages/israel.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Emmanuel Dunand / AFP]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 israel">Israel (as a state)</span>
 <p className="text-white explaintext">The first mention of "Israel" in these documents was in UN resolution 242 (1967) which called for the "withdrawal of Israeli armed forces from territories occupied in the recent conflict".</p>
 <p className="text-white explaintext">In 1967, Israel completely occupied Gaza and the West Bank, including East Jerusalem.</p>
 <p className="text-white explaintext">Trump's new plan repeatedly refers to the <span className="hiisrael">"State of Israel" and "the Palestinians"</span>, further highlighting the disparity between the two.</p>
 <small className="text-white">The topic "Israel" is only counted when referenced as a state - ie not "Israeli" people.</small>
 </section>
 <section>
   <img src='./jpg/maps/israel.png' className="fluid" alt=""/>

 </section>
 </Col>
 </Row>
 <Row className="boxcard">
 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section> 
   <img src='./jpg/chartimages/jerusalem.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Showkat Shafi / Al Jazeera]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 jerusalem">Jerusalem</span>
 <p className="text-white explaintext">Jerusalem, the holy city shared by Muslims, Christians and Jews, features prominently in UN Security Council Resolution 478 (1980).</p>
 <p className="text-white explaintext">The resolution <span className="hijerusalem">rejected Israel's claim to Jerusalem as the "complete and united" capital of Israel</span> and was adopted with 14 votes to none, with the United States abstaining.</p>
 <p className="text-white">Trump's 2020 plan contradicts Resolution 478 by calling for Jerusalem to "remain the sovereign capital of the State of Israel".</p>
 </section>
 <section>
   <img src='./jpg/maps/jerusalem.png' className="fluid" alt=""/>



 </section>
 </Col>

 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section>  
   <img src='./jpg/chartimages/refugees.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Said Khatib / AFP]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 refugee">Refugees</span>
 <p className="text-white explaintext">Hundreds of thousands of refugees fled to neighbouring Arab states in 1948 and again in after the war in 1967.</p>
 <p className="text-white explaintext">According to UN Resolution 194 (1948): “Refugees wishing to return to their homes and live at peace with their neighbours should be permitted to do so.”</p>
 <p className="text-white">Under Trump's new plan, the "Right of Return" of Palestinian refugees, which is a universally recognised <span className="hirefugee">right in international refugee law, is mentioned once but only to say - "there shall be no right of return".</span></p>
 </section>
 <section>
   <img src='./jpg/maps/refugees.png' className="fluid" alt=""/>

 </section>
 </Col>
 </Row>
 <Row className="boxcard">
 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section>

   <img src='./jpg/chartimages/occupation.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Hazem Bader / AFP]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 occupation">Occupation</span>
 <p className="text-white explaintext">The Israeli occupation is the largest and longest-lasting occupation of modern times.</p>
 <p className="text-white explaintext">Israel militarily occupied the Gaza Strip and the West Bank, including East Jerusalem, in June 1967.</p>
 <p className="text-white explaintext">The term <span className="hioccupation">"occupation" is strikingly missing from Trump's 2020 plan. The only mention of the word is as a synonym for job or profession.</span></p>
 </section>
 <section>
   <img src='./jpg/maps/occupation.png' className="fluid" alt=""/>

 </section>
 </Col>

 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section>  
   <img src='./jpg/chartimages/settlements.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Ahmad Gharabli / AFP]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 settlements">Settlements</span>
 <p className="text-white explaintext">Israel's building of settlements in the Occupied Palestinian Territories is illegal under international law.</p>
 <p className="text-white explaintext">By 2018, there were 611,000 Israeli settlers living in 250 settlements in the occupied West Bank, including East Jerusalem.</p>
 <p className="text-white explaintext">Trump's 2020 plan legitimises these settlements and says that <span className="hisettlements">Israel "will not have to uproot any settlements, and will incorporate the vast majority of Israeli settlements into contiguous Israeli territory."</span></p>
 </section>
 <section>
   <img src='./jpg/maps/settlements.png' className="fluid" alt=""/>
 
 </section>
 </Col>
 </Row>
<Row className="boxcard">
 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section>   
   <img src='./jpg/chartimages/jewish.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Ahmad Gharabli / AFP]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 jew">Jewish</span>
 <p className="text-white explaintext">Trump's plan repeatedly describes Israel as the "Jewish State".</p>
 <p className="text-white explaintext">This language has <span className="hijew">not been used to refer to the State of Israel since prior to its founding in 1948.</span></p>
 <p className="text-white explaintext">The Balfour Declaration (1917), which was a public pledge by Britain, promised the establishment of "a national home for the Jewish people" in Palestine.</p>
 </section>
 <section>
   <img src='./jpg/maps/jewish.png' className="fluid" alt=""/>

 </section>
 </Col>

 <Col lg="6" md="6" sm="12" xs="12" className="showkat text-left">
 
 <section> 
   <img src='./jpg/chartimages/unitednations.jpg' className="fluid" alt=""/>
   <small className="captionshowkat"><span> [Sorin Furcoi / Al Jazeera]</span></small>
   <p>&nbsp;</p>
   <span className="display-3 unitednations">United Nations</span>
 <p className="text-white explaintext">The international community as represented by the UN has overwhelmingly condemned Israel's occupation of the Palestinian Territories.</p>
 <p className="text-white explaintext">In 1947, the UN General Assembly voted in favour of partitioning Palestine between Jews (with control of 55% of the land) and Palestinians (with 45%).</p>
 <p className="text-white explaintext">Trump's new conceptual map would <span className="hiun">annex huge parts of the occupied West Bank and give Palestinians control of only 15% of historical Palestine.</span></p>
 </section>
 <section>
 <img src='./jpg/maps/unitednations.png' className="fluid" alt=""/>

 </section>
 </Col>
 </Row>
 <br/>

        </Container>
        </Container>
    )


}
}
export default Topics